module.exports = __webpack_public_path__ + "static/media/manu.ade2f191.jpg";